import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, Inject, Input, Output, EventEmitter, PLATFORM_ID, OnDestroy, ViewChildren, ViewChild, ElementRef, QueryList, HostBinding } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
//import $ from 'jquery';

import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Subject, combineLatest } from 'rxjs';
import { error } from 'node:console';
import { Tooltip } from 'bootstrap';
declare var bootstrap: any;

@Component({
  selector: 'app-rep-approver-timesheet',
  standalone: true,
  imports: [CommonModule, TranslateModule, HttpClientModule, FormsModule, RouterLink],
  providers: [Base64UrlService],
  templateUrl: './rep-approver-timesheet.component.html',
  styleUrl: './rep-approver-timesheet.component.scss'
})
export class RepApproverTimesheetComponent {
    @ViewChild('btnclaim_history_popup') cngButton!: ElementRef;
    @ViewChild('btntraining_history_popup') cngHistoryButton!: ElementRef;
    // 代理処理タブから埋め込み起動する場合の入力
    @Input() inputId?: string;
    @Input() inputUserId?: string;
    @Input() embeddedMode?: boolean;
    @HostBinding('class.embedded-mode') get isEmbeddedMode() { return !!this.embeddedMode; }
    @Output() backClicked = new EventEmitter<void>();
    @Output() logClicked = new EventEmitter<void>();
    
      userName: any;
      lang: any;
      userCode: any;
      timeSheetTopPannel: any;
      tsSummary: any = null;
      monthDropdown: any;
      timeSheetData: any;
      timeSheetCmnData: any;
      jobOrderData: any;
      noteTypes: any;
      expensesTypes: any;
      timesheetId: any;
      timesheetIdOrg: any;
      userId: any;
      userIdOrg: any;
      editingRow: number | null = null;
      dashboard_msg: string | null = null;
      msgType: any;
      showSaveToast = false;
      private saveToastTimer: ReturnType<typeof setTimeout> | null = null;
      selectAll = false;
      selectedTimesheetId: number | string = '';
      isButtonDisabled: boolean = false;
      expandedRows: boolean[] = [];
      expandedRowsButton: boolean[] = [];
      savedScrollPositions: { [key: number]: number } = {};
      thread_msg: any;
      yearList: number[] = [];
      monthList: number[] = [];
      dayList: number[] = [];
      selectedYear: number |null = null;
      selectedMonth: number | null = null;
      selectedDay: number | null = null;
      historyComments: string = '';
      historyCommentsDis: string = '';
      trainingComments: string = '';
      trainingCommentsDis: string = '';
      archive: boolean = false;
      isRejectEditing: boolean = false;
      isCommentDirty = false;
      originalComment: string = '';
      
      dtOptions: any = {};
      dtTrigger: Subject<any> = new Subject<any>();
      constructor(private route: ActivatedRoute, private auth: AuthService,private translate: TranslateService, private pageTitle: PageTitleService, private ts: TimesheetService, private en: EncryptionService, private http: HttpClient, private router: Router,
       private safeUrl: Base64UrlService, @Inject(PLATFORM_ID) private platformId: Object
      ) { 
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 
    
          this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
          console.log(this.lang)
          translate.use(this.lang);
        }
      }
    
      ngOnInit() {
        console.log('🚀 rep-approver-timesheet component initialized');
        console.time('⏱️ Total ngOnInit');
        
        this.userCode = this.auth.getCode();
        if (isPlatformBrowser(this.platformId)) {
          const rawId = this.inputId ?? this.route.snapshot.params['id'];
          const rawUserId = this.inputUserId ?? this.route.snapshot.params['userId'];
          // this.timesheetId = this.en.decryptionAES(rawId);
          this.timesheetId = this.en.decryptionAES(Base64UrlService.decode(rawId));
          
          this.timesheetIdOrg = rawId;
          this.userId = this.en.decryptionAES(Base64UrlService.decode(rawUserId));
          this.userIdOrg = rawUserId;
          this.dashboard_msg = null;
          this.dashboard_msg = localStorage.getItem('dashboard_msg');    
          localStorage.removeItem('dashboard_msg');
          this.thread_msg = null;
        
          this.userName = this.auth.getName();
          this.pageTitle.setTitle('menu.proxyapproval');
          this.selectedTimesheetId = this.timesheetId;
          this.getMonthDropDown();
          this.getTimesheetData();
        }
        
        console.timeEnd('⏱️ Total ngOnInit');
      }
    
      @ViewChildren('tooltipEl', { read: ElementRef }) tooltipElements!: QueryList<ElementRef>;
    
      ngAfterViewInit() {
        this.initTooltips();
        this.tooltipElements.changes.subscribe(() => this.initTooltips());
      }
    
      private initTooltips(): void {
        this.tooltipElements.forEach((el) => new Tooltip(el.nativeElement));
      }
      
      triggerClick() {
        this.cngButton.nativeElement.click();
        this.cngHistoryButton.nativeElement.click();
      }
    
      getShortText(text: string, limit: number = 30): string {
        return text && text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    
      getMonthDropDown() {
        // this.ts.getMonthList()
        // console.log(this.userId);
        this.ts.getMonthWithTimesheetIdNew(this.userId)
        .subscribe({
          next: (resMonthList: any) => {
            if (resMonthList.status) {
              this.monthDropdown = resMonthList.data;          
            } else {
              this.dashboard_msg = "dataRetriveErrorMessage";
              this.msgType = "danger";           
              this.isButtonDisabled = false;
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            // console.log(this.monthDropdown);        
          },
          error: (err: any) => {        
            if (err.status == 401) {
              this.auth.logout();
          return
            } else {
              this.dashboard_msg = "dataRetriveErrorMessage";
              this.msgType = "danger";           
              this.isButtonDisabled = false;
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }
        });
      }
    
      getTimeDiffInMinutes(start: string, end: string) {    
        const startTime = new Date(start).getTime();
        const endTime = new Date(end).getTime();
        const diffMs = endTime - startTime;
        const diffMin = Math.floor(diffMs / (1000 * 60));    // convert to minutes
        let rt = this.addMinutesWithOverflow(start, diffMin).split('T')[1].split(':');
        let finalEndTime = `${parseInt(rt[0], 10)}:${rt[1]}`;
        return finalEndTime;
      }
      
      addMinutesWithOverflow(dateStr: string, minutes: number): string {
        const base = new Date(dateStr);
      
        // Add minutes normally
        const updated = new Date(base.getTime() + minutes * 60000);
      
        // Calculate total minutes since start of the day
        const diffMs = updated.getTime() - new Date(base.toDateString()).getTime();
        const totalMinutes = diffMs / 60000;
      
        const hours = Math.floor(totalMinutes / 60);
        const mins = Math.floor(totalMinutes % 60);
      
        // Format back as overflow time
        const hh = hours.toString().padStart(2, '0');
        const mm = mins.toString().padStart(2, '0');
      
        const datePart = dateStr.split("T")[0];
      
        return `${datePart}T${hh}:${mm}:00`;
      }
    
      getTimesheetData() {
        console.time('⏱️ Total getTimesheetData');

        const getTimeSheetById = this.ts.getTimeSheetById(this.timesheetId);
        const getTsInfoSummary = this.ts.getTsInfoSummary(this.timesheetId);
        const getNoteTypes     = this.ts.getNoteTypes();
        const getExpensesTypes = this.ts.getExpensesTypes();

        combineLatest([getTimeSheetById, getTsInfoSummary, getNoteTypes, getExpensesTypes])
          .subscribe({
            next: ([res, summary, resNote, resExpenses]: [any, any, any, any]) => {
              if (res.status) {
                console.log('📊 Raw data count:', res.data.lineItems?.length || 0);
                console.time('⏱️ Map and Calculate');

                this.timeSheetCmnData = res.data.timeSheet;
                this.archive = res.data.isArchived;
                this.originalComment = this.timeSheetCmnData.comments ?? '';
                this.isCommentDirty = false;
                this.historyComments = this.timeSheetCmnData.complaintComments;
                this.historyCommentsDis = this.timeSheetCmnData.complaintComments;
                this.trainingComments = this.timeSheetCmnData.trainingComments;
                this.trainingCommentsDis = this.timeSheetCmnData.trainingComments;
                this.selectedYear = this.getYearN(this.timeSheetCmnData.complaintCmtUpdateDate);
                this.selectedMonth = this.getMonthN(this.timeSheetCmnData.complaintCmtUpdateDate);
                this.selectedDay = this.getDayN(this.timeSheetCmnData.complaintCmtUpdateDate);

                // 🚀 最適化: データ取得時に一度だけ計算
                this.timeSheetData = res.data.lineItems.map((item: any) => {
                  // 事前計算
                  const dayWeekData = this.getDayWeekKey(item.dayDate);
                  const statusData = this.getStatus(item.status);
                  const noteData = this.getNote(item.noteId);
                  const expensesData = this.getExpenses(item.expenseId);
                  const statusClass = this.getClass(item.status);

                  return {
                    ...item,
                    // Convert start/finish/breaks into HH:mm for direct binding
                    startTime: (item.startTime == '1972-01-12T00:00:00') ? '' : String(this.toTimeString(item.startTime)).padStart(2, '0'),
                    startTimeOrg: item.startTime,
                    endTime: (item.endTime == '1972-01-12T00:00:00') ? '' : String(this.getTimeDiffInMinutes(item.startTime, item.endTime)).padStart(2, '0'),
                    endTimeOrg: item.endTime,
                    markedForSubmit: false,
                    // 事前計算されたプロパティ
                    dayWeekDay: dayWeekData.day,
                    dayWeekKey: dayWeekData.weekdayKey,
                    dayWeekShort: dayWeekData.shortweekday,
                    statusKey: statusData.statusKey,
                    statusClass: statusClass,
                    noteKey: noteData.noteKey,
                    expensesKey: expensesData.expensesKey
                  };
                });

                console.timeEnd('⏱️ Map and Calculate');
                console.log('📊 Processed data count:', this.timeSheetData?.length || 0);
                console.log('✅ Data ready, Angular will now render...');

                this.timeSheetTopPannel = res.data.timesheetSummary[0];
                this.tsSummary = summary;
                this.jobOrderData = res.data.jobOrder;

                if (resNote.status) {
                  this.noteTypes = resNote.data;
                } else {
                  this.dashboard_msg = resNote.message;
                  this.msgType = "danger";
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }

                // 業務交通費(typeID=2)を上、その他立替金(typeID=1)を下に表示
                if (resExpenses.status) {
                  this.expensesTypes = [...resExpenses.data].sort((a: any, b: any) => b.typeID - a.typeID);
                } else {
                  this.dashboard_msg = resExpenses.message;
                  this.msgType = "danger";
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }

                const currentYear = new Date().getFullYear();
                this.yearList = Array.from({ length: 5 }, (_, i) => currentYear - i);
                this.monthList = Array.from({ length: 12 }, (_, i) => i + 1);
                this.dayList = Array.from({ length: 31 }, (_, i) => i + 1);

                console.timeEnd('⏱️ Total getTimesheetData');
                console.log('🎉 All data loaded!');
              } else {
                this.dashboard_msg = res.message;
                this.msgType = "danger";
                this.isButtonDisabled = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            },
            error: (err: any) => {
              console.log(err);
              console.timeEnd('⏱️ Total getTimesheetData');
              if (err.status == 401) {
                this.auth.logout();
                return;
              } else {
                this.dashboard_msg = "dataRetriveErrorMessage";
                this.msgType = "danger";
                this.isButtonDisabled = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
          });
      }
      getMonth(dateStr: string): string {
        const [day, month, year] = dateStr.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', { month: 'short' });
      }
      getYear(dateStr: string): string {
        const [day, month, year] = dateStr.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', { year: 'numeric' });
      }

      getOptionTitle(date: any): string {
        const year = this.getYear(date.weekEnding);
        const month = this.translate.instant('DDMONTH.' + this.getMonth(date.weekEnding));
        const term = date.contractTerm ? ` ${date.contractTerm}` : '';
        return `${year} ${month} (${date.companyName}${term})`;
      }

      getMonthYear(dateStr: string): string {
        const [day, month, year] = dateStr.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
      }
    
      getYearN(dateStr: string) {
        const date = new Date(dateStr);
        const year = date.getFullYear();    
        return year;
      }
    
      getMonthN(dateStr: string) {
        const date = new Date(dateStr);
        const month = date.getMonth()+1;
        return month;
      }
    
      getDayN(dateStr: string) {
        const date = new Date(dateStr);
        const day = date.getDate();
        return day;
      }
    ngOnDestroy(): void {
        // コンポーネント破棄時（proxyOperation 変更による *ngIf アンマウント）にタイトルをクリア
        this.pageTitle.setTitle('');
        if (isPlatformBrowser(this.platformId)) {
          const table = ($('#attendanceTable') as any).DataTable();
          if (table) {
            table.destroy(true);
          }
        }
      }
      toggleAllApprovals(event: Event) {
        const input = event.target as HTMLInputElement;
        const isChecked = input.checked;
    
        this.selectAll = isChecked; // update header state
    
        // Update all rows
        this.timeSheetData.forEach((item: any) => {
          if(item.status == 20)
            item.markedForSubmit = isChecked;
        });
    
        this.dashboard_msg = null;
        console.log('All Approve checkboxes set to:', isChecked);
      }
    
      onRowApproveChange() {
        this.selectAll = this.timeSheetData.every((item: any) => item.markedForSubmit);
      }
    
      chkSubmitCnt() {
        // console.log(chkStatus)
        const total = this.timeSheetData.length;
        const checked = this.timeSheetData.filter((item: any) => item.markedForSubmit).length;
        // console.log(this.timeSheetData.length);
        // console.log(this.timeSheetData.filter((item: any) => item.markedForSubmit).length);
        this.selectAll = (total > 0 && checked === total);
        this.dashboard_msg = null;
      }
      onSave(): void {
        const startTimeRegex = /^(?:0[1-9]|1\d|2[0-3]|[1-9]):[0-5]\d$/;
        let hasError = false;
        let cntApprove = 0;
        $(".timeSheet_row").each(function () { 
          const isChecked = $(this).find(".chkApproveStatus").is(":checked");
    
          if (isChecked) {
            cntApprove += 1; 
          } else {
            console.log("This row's checkbox is NOT checked");
          }
        })
        // console.log(cntApprove);
        if (cntApprove == 0) {
          hasError = true;
        }
        // stop if any error found
        // if (hasError) {
        //   // console.log("Validation failed. Please correct errors before submitting.");
        //   this.dashboard_msg = "validationApproverErrorMessage";
        //   this.msgType = "danger";
        //   return;
        // } 
        
        // Prepare payload
        // First filter the array based on the checkbox checked then map the filtrered array
        const items = this.timeSheetData.filter((item: any) => item.markedForSubmit).map((item: any) => ({
          timesheetLineItemId: item.timesheetLineItemId ?? 0,
          status: item.markedForSubmit ? 40 : item.status, 
          etcRemarks: item.etcRemarks ?? '',
          rowVersion: item.rowVersion ?? null,
        }));
    
        const comments = this.timeSheetCmnData.comments;
        const payload = {
          timesheetId: this.timesheetId,
          items,
          comments: comments
        };
    
        // console.log(payload);
        // return;
        this.ts.approveRejectTimeSheet(payload)
          .subscribe({
            next: (res: any) => {
              if (res.status) {
                this.triggerSaveToast();
                this.getTimesheetData();
                this.isButtonDisabled = false;
              } else {
                this.dashboard_msg = res.message; //"dataSaveErrorMessage";
                this.msgType = "danger";
                this.getTimesheetData();
                this.isButtonDisabled = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            },
            error: (err: any) => {
              console.log(err);
              if (err.status == 401) { 
                this.auth.logout();
                return
              } else {
                this.dashboard_msg = "dataSaveErrorMessage";
                this.msgType = "danger";
                this.getTimesheetData();
                this.isButtonDisabled = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
        })
      }
    
      editReject(index: number) {
        // console.log(event);
        // const input = event.target as HTMLInputElement;
        // const isChecked = input.checked;
        // this.editingRow = index;
        if (this.timeSheetData[index].markedForReject) {      
          this.editingRow = index;
          this.isRejectEditing = true;
          this.expandedRows[index] = true;
          this.expandedRowsButton[index] = true;
        } else {
          this.editingRow = null;
          this.isRejectEditing = false;
        }    
      }
    
      cancelReject(index: number) {
        // console.log("cancel reject");
        this.timeSheetData[index].markedForReject = false;
        this.editingRow = null;
        this.isRejectEditing = false;
        this.selectAll = false;
        this.expandedRows[index] = false;
        this.expandedRowsButton[index] = false;
        const savedY = this.savedScrollPositions[index];
        if (savedY !== undefined) {
          window.scrollTo({ top: savedY, behavior: 'smooth' });
          delete this.savedScrollPositions[index];
        }
        this.getTimesheetData();
      }
      saveReject(index: number) {
        // console.log("save reject");
        this.editingRow = null;
        const item = this.timeSheetData[index];
        
        // Validate breakMinutes for this row
        // if (this.isBreakMinutesInvalid(item)) {
        //   // Optionally, set a flag or just return
        //   return;
        // }
    
        // Prepare single row payload
        const items = [{
          timesheetLineItemId: item.timesheetLineItemId ?? 0,
          // dayDate: item.dayDate ?? '',
          // startTime: this.toIsoString(item.startTime, item.startTimeOrg),
          // endTime: this.toIsoString(item.endTime, item.endTimeOrg) ?? '',
          // midnightBreakMinutes: item.midnightBreakMinutes ?? 0,
          // breakMinutes: item.breakMinutes ?? 0,
          // noteId: item.noteId ?? 0,
          // expenseId: item.expenseId ?? 0,
          status: 30,
          // cost: item.cost ?? 0,
          // whf: item.whf ?? false,
          etcRemarks: item.etcRemarks ?? '',
          rowVersion: item.rowVersion ?? null
        }];
    // timesheetId: this.timesheetId,
        const payload = {      
          items
        };
    
        // console.log(payload);
        // return false;
    
        this.ts.approveRejectTimeSheet(payload)
          .subscribe({
            next: (res: any) => {
              if (res.status) {
                this.triggerSaveToast();
                this.getTimesheetData();
                this.isButtonDisabled = false;
                this.isRejectEditing = false;
                this.selectAll = false;
                this.expandedRows[index] = false;
                this.expandedRowsButton[index] = false;
                const savedY = this.savedScrollPositions[index];
                if (savedY !== undefined) {
                  window.scrollTo({ top: savedY, behavior: 'smooth' });
                  delete this.savedScrollPositions[index];
                }
              } else {
                this.dashboard_msg = res.message;"dataSaveErrorMessage";
                this.msgType = "danger";
                this.getTimesheetData();
                this.isButtonDisabled = false;
                this.isRejectEditing = false;
                this.selectAll = false;
                this.expandedRows[index] = false;
                this.expandedRowsButton[index] = false;
                delete this.savedScrollPositions[index];
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            },
            error: (err: any) => {
              console.log(err);
              if (err.status == 401) { 
                this.auth.logout();
                return
              } else if (err.status === 409) {
                this.dashboard_msg = "dataConflictErrorMessage";
                this.msgType = "danger";
                this.ts.invalidateTimesheetDataCache(this.timesheetId);
                this.getTimesheetData();
                this.isButtonDisabled = false;
                this.isRejectEditing = false;
                this.selectAll = false;
                this.expandedRows[index] = false;
                this.expandedRowsButton[index] = false;
                delete this.savedScrollPositions[index];
                window.scrollTo({ top: 0, behavior: 'smooth' });
              } else {
                this.dashboard_msg = "dataSaveErrorMessage";
                this.msgType = "danger";
                this.getTimesheetData();
                this.isButtonDisabled = false;
                this.isRejectEditing = false;
                this.selectAll = false;
                this.expandedRows[index] = false;
                this.expandedRowsButton[index] = false;
                delete this.savedScrollPositions[index];
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
        })
      }
      reset() {
        this.dashboard_msg = null;
      }

      triggerSaveToast(): void {
        if (this.saveToastTimer !== null) { clearTimeout(this.saveToastTimer); }
        this.showSaveToast = true;
        this.saveToastTimer = setTimeout(() => {
          this.showSaveToast = false;
          this.saveToastTimer = null;
        }, 1000);
      }

      markCommentDirty(): void {
        this.isCommentDirty = true;
      }

      onSaveComment(): void {
        const payload = {
          timesheetId: this.timesheetId,
          items: [],
          comments: this.timeSheetCmnData.comments
        };
        this.ts.approveRejectTimeSheet(payload).subscribe({
          next: (res: any) => {
            if (res.status) {
              this.originalComment = this.timeSheetCmnData.comments ?? '';
              this.isCommentDirty = false;
              this.triggerSaveToast();
            } else {
              this.dashboard_msg = res.message;
              this.msgType = 'danger';
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          },
          error: (err: any) => {
            if (err.status === 401) {
              this.auth.logout();
            } else {
              this.dashboard_msg = 'dataSaveErrorMessage';
              this.msgType = 'danger';
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }
        });
      }

      onCancelComment(): void {
        this.timeSheetCmnData.comments = this.originalComment;
        this.isCommentDirty = false;
      }
      /*----------- Timesheet format logic ------------*/
      getDayWeekKey(dateString: string): { day: string, weekdayKey: string, shortweekday: string } {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const weekdayIndex = date.getDay();
    
        const weekdayKeys = [
          'WEEKDAYS.SUNDAY',
          'WEEKDAYS.MONDAY',
          'WEEKDAYS.TUESDAY',
          'WEEKDAYS.WEDNESDAY',
          'WEEKDAYS.THURSDAY',
          'WEEKDAYS.FRIDAY',
          'WEEKDAYS.SATURDAY'
        ];
    
        const weekdayKeysShort = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    
        return { day, weekdayKey: weekdayKeys[weekdayIndex], shortweekday: weekdayKeysShort[weekdayIndex] };
      }
    
      getStatus(status: number): { statusKey: string } {
        let statusIndex = 0;
        if (status == 40) {
          statusIndex = 4;
        } else if (status == 30) {
          statusIndex = 3;
        } else if (status == 20) {
          statusIndex = 1;
        } else {
          statusIndex = 0;
        }
        const statusKeys = [
          "SHORTSTATUS.NOTSUBMIT",
          "SHORTSTATUS.SUBMIT",
          "SHORTSTATUS.FIX",
          "SHORTSTATUS.REJECT",
          "SHORTSTATUS.APPROVE"
        ];
        return {statusKey: statusKeys[statusIndex]}
      }
    
      getStartTime(dateString: string): string {
        const date = new Date(dateString);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    
     
      toTimeString(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const hours = date.getHours().toString();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    
      fncCng(event: any) {
        const target = event.target as HTMLSelectElement;
        this.timesheetId = target.value;
        this.timesheetIdOrg = Base64UrlService.encode(this.en.encryptionAES(this.timesheetId.toString()));
        this.getTimesheetData();
      }
    
      private toIsoString(time: any, originalIso: string): string {
        // console.log(time);
        if (typeof time === 'object' && time !== null) {      
          const date = new Date(time);
          const hours = date.getHours();
          const minutes = date.getMinutes();            
          time = `${String(hours)}:${String(minutes)}`;
        }
        const [hours, minutes] = time.split(':').map(Number);
        // const date = new Date(originalIso || new Date());
        // date.setHours(hours, minutes, 0);
        
        const date = new Date(originalIso || new Date());    
        // Create a new Date object with today's date and given time
        const yyyy = String(date.getFullYear());
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');  
        const hh = String(hours).padStart(2, '0');
        const min = String(minutes).padStart(2, '0');
    
        return `${yyyy}-${mm}-${dd}T${hh}:${min}:00.000Z`;
      }
    
      
      getEndTime(dateString: string): string {
        const date = new Date(dateString);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    
      getNote(note: number): { noteKey: string } {
        let statusIndex = 0;
        if (note == 10) {
          statusIndex = 0;
        } else if (note == 20) {
          statusIndex = 1;
        } else if (note == 40) {
          statusIndex = 2;
        } else if (note == 50) {
          statusIndex = 3;
        } else {
          statusIndex = 4;
        }
        const noteKeys = [
          "",
          "NOTEDD.PaidLeave",
          "NOTEDD.Tardiness",
          "NOTEDD.Absence",
          "NOTEDD.SeeComment"
        ];
        return {noteKey: noteKeys[statusIndex]}
      }
      
      getExpenses(expenses: number): { expensesKey: string } {
        let statusIndex = 0;
        if (expenses == 0) {
          statusIndex = 0;
        } else if (expenses == 1) {
          statusIndex = 1;
        } else if (expenses == 2) {
          statusIndex = 2;
        }
        const expensesKeys = [
          "",
          "ExpenseDD.AdvancePayment",
          "ExpenseDD.Transportation"
        ];
        return {expensesKey: expensesKeys[statusIndex]}
      }
    
      getClass(status: number): string {
        if(status == 10 || status == 0){
          return 'tr_non_submit';
        } else if(status == 20){
          return 'tr_submit';
        } else if(status == 30){
          return 'tr_reject';
        } else if(status == 40){
          return 'tr_approve';
        } else {
          return 'tr_non_submit';
        }
      }
    
      isBreakMinutesInvalid(item: any): boolean {
        return (
          item.breakMinutes === '' ||
          item.breakMinutes === null ||
          isNaN(item.breakMinutes) ||
          String(item.breakMinutes).trim() === ''
        );
      }
    
      toggleBelowRows(index: number): void {
        const opening = !this.expandedRows[index];
        if (opening) {
          this.expandedRows.forEach((isOpen, i) => {
            if (isOpen && i !== index) {
              this.expandedRows[i] = false;
              this.expandedRowsButton[i] = false;
              delete this.savedScrollPositions[i];
            }
          });
        }
        this.expandedRows[index] = opening;
        this.expandedRowsButton[index] = opening;
        if (opening) {
          this.savedScrollPositions[index] = window.scrollY;
          setTimeout(() => {
            const el = document.getElementById(`timeSheet_row_${index}`);
            if (el) {
              const headerEl = document.querySelector('header') as HTMLElement;
              const headerH = headerEl ? headerEl.offsetHeight : 70;
              const top = el.getBoundingClientRect().top + window.scrollY - headerH;
              window.scrollTo({ top, behavior: 'smooth' });
            }
          }, 350);
        } else {
          if (this.editingRow === index) {
            this.cancelReject(index);
            return;
          }
          const savedY = this.savedScrollPositions[index];
          if (savedY !== undefined) {
            window.scrollTo({ top: savedY, behavior: 'smooth' });
            delete this.savedScrollPositions[index];
          }
        }
      }
    
      onRejectClick(item: any): void {
        if (item.status === 30 || item.status === 20) {      
          // console.log(this.lang + " - - " + );item.timesheetLineItemId
          this.ts.getEtcThread(item.timesheetLineItemId, this.lang )
          .subscribe({
            next: (res: any) => {
                this.thread_msg = res;
                // console.log(this.thread_msg);
              },
              error: (err: any) => {
                console.log(err)
                if(err.status == 401){
                  this.auth.logout()
            return
                }
              }
          })
    
        }
      }
    
      threadClose() {
        this.thread_msg = null;
      }
    
      formatDateTime(dateString: string): string {
        const date = new Date(dateString);
    
        const year = date.getFullYear();
        const month = date.toLocaleString('en-US', { month: 'short' }); // "Oct"
        const day = date.getDate().toString().padStart(2, '0');
    
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
    
        return `${year}-${month}-${day} : ${hours}:${minutes}`;
      }
      
      formatClaimDate(dateString: string): string {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth()+1).toString().padStart(2, '0'); // "Oct"
        const day = date.getDate().toString().padStart(2, '0');
    
        return `${year}-${month}-${day}`;
      }
    
    
      dwnPdf(id: any) {
        this.ts.getPdf(id )
          .subscribe({
            next: (res: any) => {
                const blob = new Blob([res.body ?? res], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
              },
              error: (err: any) => {
                console.log(err)
          if (err.status == 401) {
            this.auth.logout();
            return
          }
              }
          })
      }
    
      saveHistory() {    
    
    //     let year = this.selectedYear;
    //     let month = String(this.selectedMonth).padStart(2, '0');
    //     let day = String(this.selectedDay).padStart(2, '0');
        
    //     let updateDate = `${year}-${month}-${day}T00:00:00.000Z`;
    // ,
    //       "complaintCmtUpdateDate": updateDate
        const payLoad =
        {
          "timesheetId": this.timesheetId,
          "complaintComments": this.historyComments
        }
        // const modalElement: any = document.getElementById('claim_history_popup');
        // if (!modalElement) return;
        // const modalInstance = bootstrap.Modal.getInstance(modalElement)
          // || new bootstrap.Modal(modalElement);   
        // const modalInstance = (bootstrap.Modal.getOrCreateInstance);
          // ? bootstrap.Modal.getOrCreateInstance(modalElement)
          // : (bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement));
        // console.log(payLoad)
        // return;
        this.ts.updateClaimHistory(payLoad)
          .subscribe({
            next: (res: any) => {
              if (res.status) {
                
                // modalElement.addEventListener(
                //     'hidden.bs.modal',
                //     () => {
                //       bootstrap.Modal.getInstance(modalElement)?.dispose();
                //       this.getTimesheetData();          // SAFE HERE
                //     },
                //     { once: true }
                //   );
    
                //   modalInstance?.hide(); 
                // modalInstance?.hide();
                // modalElement.addEventListener('hidden.bs.modal', () => {
                //   // this.getTimesheetData();
                //   try { modalInstance.dispose(); } catch(e) {}
                // }, { once: true });
                // modalElement.addEventListener('hidden.bs.modal', () => {
                //   this.getTimesheetData();
                //   bootstrap.Modal.getInstance(modalElement)?.dispose();
                // }, { once: true });
                // modalInstance?.hide();
                // setTimeout(() => {
                //   // document.body.classList.remove('modal-open');
                //   document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                //   try { bootstrap.Modal.getInstance(modalElement)?.dispose(); } catch(e) {}
                // }, 300);
                // $("#btnclaim_history_popup").click();
                // document.getElementById('btnclaim_history_popup')?.click();
                this.triggerClick();
                this.getTimesheetData();
              } else {
                alert(res.message);
              }
            },
            error: (err: any) => {
              console.log(err.message)
              if (err.status == 401) {
                this.auth.logout()
          return
              }
            }
        })
      }
    
      saveTraining() {    
        const now = new Date();
        const updateDate = now.toISOString();
        
        const payLoad =
        {
          "timesheetId": this.timesheetId,
          "trainingComments": this.trainingComments,
          "trainingCmtUpdateDate": updateDate
        }
        const modalElement = document.getElementById('training_history_popup');
        const modalInstance = bootstrap.Modal.getInstance(modalElement) 
          || new bootstrap.Modal(modalElement);
        
        this.ts.updateTrainingHistory(payLoad)
          .subscribe({
            next: (res: any) => {
              if (res.status) {
                // modalInstance.hide();
                // document.getElementById("btntraining_history_popup")?.click();
                // $("#btntraining_history_popup").click();
                this.triggerClick();
                this.getTimesheetData();
                // setTimeout(() => {
                //   document.body.classList.remove('modal-open');
                //   document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                // }, 300);
              } else {
                alert(res.message);
              }
            },
            error: (err: any) => {
              console.log(err.message)
              if (err.status == 401) {
                this.auth.logout()
          return
              }
            }
        })
      }
      
      // 🚀 trackBy関数 - パフォーマンス最適化
      trackByTimesheetLineItemId(index: number, item: any): any {
        return item.timesheetLineItemId || index;
      }

  get hasNoApprovableRows(): boolean {
    return !this.timeSheetData?.some((item: any) => item.status == 20);
  }

  get hasCheckedRows(): boolean {
    return this.timeSheetData?.some((item: any) => item.markedForSubmit) ?? false;
  }
}
